import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconAlignedProps, IconRender } from '../types.ts';

const ArrowDiagonal = React.forwardRef<SVGSVGElement | null, IconAlignedProps>(function ArrowDiagonal({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M16.083 6.81507L7.55145 7.11084C7.27453 7.12044 7.04261 6.90302 7.03435 6.62606L7.01959 6.1317C7.01138 5.85662 7.22701 5.62662 7.50204 5.61709L17.3966 5.27406C18.1159 5.24912 18.7037 5.83692 18.6787 6.55615L18.3357 16.4507C18.3262 16.7258 18.0962 16.9414 17.8211 16.9332L17.3267 16.9184C17.0498 16.9102 16.8323 16.6782 16.8419 16.4013L17.1377 7.8692L6.46945 18.5375C6.27418 18.7327 5.9576 18.7327 5.76234 18.5375L5.415 18.1901C5.21974 17.9949 5.21974 17.6783 5.415 17.483L16.083 6.81507Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'arrow-diagonal-icon-svg'} iconRender={iconRender} {...props} />;
});

export default ArrowDiagonal;
